import { trackPromise } from 'react-promise-tracker';
import { api } from '../../../../../../lib';
import { ContextMenuState } from '../../../../../../reducers/gerenciadorPrecos/contextMenu';
import { RuleCompositionData } from '../../../../../../reducers/ipa/priceManager/modals/ruleComposition';

export const getRuleCompositionOfferData = async (offer: ContextMenuState['offer']): Promise<RuleCompositionData> => {
  const queryFn = async () => {
    const response = await api.get(`/rules/composition/${offer.ruleId}?productsToBePricedId=${offer.id}`, {
      expectToken: true,
    });
    return response.data;
  };

  return await trackPromise(queryFn(), 'composition-rule-offer');
};
